import Evaporate from 'evaporate'
import urlBucket from '../../Root/urlBuckets'
import File from '@orionx-dev/orionsoft-parts/lib/components/fields/File'
import getEnv from 'App/Root/getEnv'
import AWS from 'aws-sdk'

const alphaNum = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
const random = (length = 10) => {
  let result = ''
  for (let i = 0; i < length; i++) {
    result += alphaNum.charAt(Math.floor(Math.random() * alphaNum.length))
  }
  return result
}

const config = {
  signerUrl: `${urlBucket}/sign_s3`,
  logging: false,
  computeContentMd5: true,
  s3Acceleration: true,
  cryptoMd5Method: function (data) {
    return AWS.util.crypto.md5(data, 'base64')
  },
  cryptoHexEncodedHash256: function (data) {
    return AWS.util.crypto.sha256(data, 'hex')
  },
}

config.aws_key = 'AKIAIYOUVH2FQQL4BWFQ'
config.bucket = ['prod', 'beta'].includes(getEnv())
  ? 'orionx-exchange-files'
  : 'orionx-exchange-files-dev'

Evaporate.create(config).then(evaporate => {
  window.evaporate = evaporate
})

const replaceS3Url = function (name) {
  return `https://s3.amazonaws.com/${config.bucket}/${name}`
}

const uploadFile = function ({ file, onProgress, onReady, onError }) {
  const id = random(10)
  const name = `${id}_${file.name}`

  window.evaporate
    .add({
      name: `static/${name}`,
      file,
      contentType: file.type,
      progress: onProgress,
    })
    .then(function (awsKey) {
      onReady({
        url: replaceS3Url(awsKey),
        meta: { s3Path: '/' + awsKey, awsKey: decodeURI(awsKey) },
      })
    })
    .catch(function (message) {
      console.log(message, 'error uploading file')
      onError(message)
    })
}

const deleteFile = function () {
  console.log('no delete function')
}
// TODO: colocar mensaje de error
export default {
  type: File,
  upload: uploadFile,
  delete: deleteFile,
}
